<script>
import { required } from 'vuelidate/lib/validators'
import AddEdit from './addedit_networks'

import axios from 'axios'

export default {
  components: { AddEdit },
	props: {
		url: {
			type: String,
			default: '/data/networks/list?withid=yes&limit=100',
		},
    action: {
      type: Boolean,
      default: true
    },
	},
	data() {
		return {
			category: 'List',
			items: [
				{
					text: 'Home',
					href: '/',
				},
				{
					text: 'Indicators View',
					active: true,
				},
			],
      network: {
        company: null,
        location: null,
        vlan: null,
        network: null,
        tags: []
      },
			appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
			tableData: [],
			totalRows: 0,
			currentPage: 1,
			perPage: 10,
			pageOptions: [10, 25, 50, 100],
			filter: '',
			filterOn: ['company', 'location', 'vlan', 'network', 'tags'],
			sortDesc: true,
      sortBy: 'network',
			fields: [
				{ key: 'company', label: 'Company', sortable: true },
				{ key: 'location', label: 'Location', sortable: true },
        { key: 'vlan', label: 'VLAN', sortable: true },
        { key: 'network', label: 'Network', sortable: true },
				{ key: 'tags', label: 'Tags', sortable: true },
        (this.action === true) ? { key: 'action', sortable: false } : {}
			],
			isBusy: true
		}
	},
	validations: {
		event: {
			title: { required },
			category: { required },
		},
	},
	computed: {
    hasRecords() {
      return this.totalRows.length > 0
    },
		rows() {
			return this.totalRows
		},
	},
	mounted () {
    const that = this
    that.$root.$on('networkCreatedOk', () => {
      that.loadData()
    })
		that.loadData()
	},
	methods: {
    loadData (src='') {
      let that = this
      that.isBusy = true
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      let dataURL = (src.length < 1 ) ?
          `${baseURL}${that.url}&limit=2000` :
          `${baseURL}${that.url}&limit=2000&rawsearch=${src}`
      dataURL = (that.start > 0 && that.end > 0) ?
          `${dataURL}&start=${that.start}&end=${that.end}` :
          `${dataURL}`
      axios.get(dataURL).then((response) => {
        if (response.status === 200) {
          that.totalRows = response.data.length
          that.tableData = response.data.map(function(entry){
            return {
              id: entry["_id"]["$oid"],
              company: entry.company || "",
              location: entry.location || "",
              vlan: entry.vlan || "",
              network: entry.network || "",
              // created:  new Date(entry.created['$date']).toLocaleString() || '',
            }
          })
          console.log('Daticos', response.data)

        }
        console.log('tableData', that.tableData)

        that.isBusy = false
      })
      .catch(function (error) {
      })
    },
    formater(val) {
      return val
      // return val.charAt(0).toUpperCase() + val.slice(1)
    },
    typeFormater(val) {
      val = val.replace('_', ' ')
      return val
    },
    editNetwork(data) {
      const that = this
      that.network = data
      this.$refs.addEditComponent.showModal()
    },
    deleteNetwork(data) {
      const that = this
      const confirmRes = confirm("Are you sure ?");
      if (confirmRes === false) {
        return
      }
      that.network = data
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      axios.post(`${baseURL}/data/networks/delete`, that.network).then(response => {
        if (response.status === 200) {
          that.loadData()
        }
      }).catch(e => {
        console.log(e);
      });
    }
  },
}
</script>

<template>
		<div>
      <div class="row mb-md-2">
        <div class="col-sm-6 col-md-6" style="text-align:left !important">
          <span>
            Found: 
            <b>
              {{ totalRows }}
            </b>
            <template v-if="showDatetime">
              at
              <b>
                {{ new Date().toLocaleString() }}
              </b>
            </template>
          </span>
        </div>

        <div class="col-sm-6 col-md-6" >
          <div
              id="tickets-table_filter"
              class="dataTables_filter text-md-right"
          >
            <label class="d-inline-flex align-items-center">
              <b-form-input
                  v-model="filter"
                  type="search"
                  placeholder="Text to search..."
                  class="form-control form-control-sm ml-2"
              ></b-form-input>
              <b-button size="sm" variant="light" @click="doSearch">
                Search
              </b-button>
            </label>
          </div>
        </div>
      </div>

      <div class="table-responsive mb-0">
        <b-table hover 
          :items="tableData"
          :fields="fields"
          :busy="isBusy"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filter"
        >
          <template v-slot:table-busy>
            <div class="text-center">
            <br><br>
            <b-spinner class="align-middle"></b-spinner>
            <strong>&nbsp;&nbsp;Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(type)="data">
            <span class="badge badge-secondary">
              {{ typeFormater(data.item.type) }}
            </span>
          </template>
          <template v-slot:cell(title)="data">
            {{ formater(data.item.title) }}
          </template>
          <template v-slot:cell(body)="data">
            {{ formater(data.item.body) }}
          </template>
          <template v-slot:cell(priority)="data">
            <span :class="data.item.priority">
              {{ formater(data.item.priority) }}
            </span>
          </template>
          <template v-slot:cell(tags)="data">
            <ul>
              <li v-for="tag in data.item.tags" style="text-align:left !important">
                {{ tag }}
              </li>
            </ul>
          </template>
          <template v-slot:cell(created)="data">
            {{ data.item.created }}
          </template>
          <template v-slot:cell(action)="data">
            <template v-if="action">
              <b-dropdown right variant="white" class="align-self-center" toggle-class="p-0">
                <template v-slot:button-content>
                  <feather type="chevron-down" class="align-middle" style="height:12px !important;width:20px !important;"></feather>
                </template>
                <b-dropdown-item @click="editNetwork(data.item)" class="notify-item">
                  <feather
                      type="edit-2"
                      class="icon-dual icon-xs mr-2 align-middle"
                  ></feather>
                  <span>Edit</span>
                </b-dropdown-item>
                <b-dropdown-item @click="deleteNetwork(data.item)" class="notify-item">
                  <feather
                      type="x"
                      class="icon-dual icon-xs mr-2 align-middle"
                  ></feather>
                  <span>Delete</span>
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </template>
        </b-table>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-6" style="text-align:left !important">
          <div id="tickets-table_length" class="dataTables_length">
            <label class="d-inline-flex align-items-center">
              Show&nbsp;
              <b-form-select
                v-model="perPage"
                size="sm"
                :options="pageOptions"
              ></b-form-select
              >&nbsp;entries
            </label>
          </div>
        </div>
        <div class="col">
          <div
            class="dataTables_paginate paging_simple_numbers float-right"
          >
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
      <AddEdit
          ref="addEditComponent"
          :title="'Edit network'"
          :operation="'update'"
          :network="network"
      />
    </div>
</template>

<style scoped>
  .critical {
    color: #DC001E
  }
  .important {
    color: orange
  }
  .recommended {
    color: #d0d020
  }
  .useful {
    color: #01AD00
  }
  .informational {
    color: #5d8aff
  }
</style>